var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"knight-to-man",class:_vm.fadeClasses},[_c('Left',{staticClass:"ktm-left"}),_c('Man',{staticClass:"man"}),_c('Right',{staticClass:"ktm-right"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }